__turbopack_context__.v({
  "sixthScreenBox": "MainPanorama-module-scss-module__QXma6q__sixthScreenBox",
  "sixthScreenContainer": "MainPanorama-module-scss-module__QXma6q__sixthScreenContainer",
  "sixthScreenContainerImg": "MainPanorama-module-scss-module__QXma6q__sixthScreenContainerImg",
  "sixthScreenIcon": "MainPanorama-module-scss-module__QXma6q__sixthScreenIcon",
  "sixthScreenText": "MainPanorama-module-scss-module__QXma6q__sixthScreenText",
  "sixthScreenTitle": "MainPanorama-module-scss-module__QXma6q__sixthScreenTitle",
  "svgClass": "MainPanorama-module-scss-module__QXma6q__svgClass",
  "videoButton": "MainPanorama-module-scss-module__QXma6q__videoButton",
});
